export default __webpack_public_path__ + "static/media/technical-head.0afd360a.jpg";